import { render } from "./NeedPlusModal.vue?vue&type=template&id=0cd4b020"
import script from "./NeedPlusModal.vue?vue&type=script&lang=js"
export * from "./NeedPlusModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__